import { Permission } from "./permission.enum";

export class UserGroup {
    Id: string;
    Name: string;
}

export class GroupFeatureViewModel {
    FeatureName: string;
    GroupId: string;
    GroupName: string;
    HasPermission: boolean;

    constructor(groupFeature: GroupFeature) {
        this.FeatureName = groupFeature.FeatureName;
        this.GroupId = groupFeature.GroupId;
        this.GroupName = groupFeature.GroupName;
        this.HasPermission = groupFeature.Permission === Permission.Allow;
    }
}

export class GroupFeature {
    FeatureName: string;
    GroupId: string;
    GroupName: string;
    Permission: Permission;
}